import settings from './settings.js'
import humanizeDuration from 'humanize-duration'

export default {
    name: 'conversions',

    // miles to km
    mi2km: function(mi) {
        return mi * 1.60934;
    },

    // km to miles
    km2mi: function(km) {
        return km / 1.60934;
    },

    // us gallons to litres
    usgal2l: function(g) {
        return g * 3.78541;
    },

    // litres to us gallons
    l2usgal: function(l) {
        return l / 3.78541;
    },

    // uk gallons to litres
    ukgal2l: function(g) {
        return g * 4.54609;
    },

    // litres to uk gallons
    l2ukgal: function(l) {
        return l / 4.54609;
    },
    
    // l/100km to mpg (us gallons)
    lp100km2mpg_us : function(lp100km){
    	return 235.2145833 / lp100km   
    },

    // l/100km to mpg (uk gallons)
    lp100km2mpg_uk : function(lp100km){
    	return 282.4809363 / lp100km
    },

    toNearest : function(num, frac) {
        let ciel = Math.ceil(num / frac) * frac;
        let floor = Math.floor(num / frac) * frac;
        //console.log("toNearest num="+num+" frac="+frac)
        //console.log("toNearest ciel="+ciel+" floor="+floor)
        if(ciel === floor){
            return ciel
        }
        if(num > (ciel - (parseFloat(frac)/2))){
            //console.log("toNearest ciel")
            return ciel
        }
        //console.log("toNearest floor")
        return floor
    },

    convertDistance : function(d){
    	let unit = settings.getDistanceUnit()
    	if (unit == 'km'){
    		return d
    	}
    	return this['km2'+unit](d)
    },
    
    convertVolume : function(d){
        let unit = settings.getVolumeUnit()
        if (unit == 'l'){
            return d
        }
        return this['l2'+unit](d)
    },
        
    formatVolume: function(d, decimals=0){
        let d2 = parseFloat(this.convertVolume(d))
        return d2.toFixed(decimals) +' '+settings.getVolumeUnit()
    },
    formatDistance : function(d, decimals=0){
        if(isNaN(d)){
            return settings.getDistanceUnit()
            
        }
    
    	let d2 = parseFloat(this.convertDistance(d))
    	if(d2 < 10){
    	    decimals = 1
    	}
    	return d2.toFixed(decimals) +' '+settings.getDistanceUnit()
    },
    formatSpeed : function(v, decimals=0){
    	let unit = settings.getDistanceUnit();
    	if (unit == 'mi'){
    	    if(this['km2'+unit](v) < 10){
    	        decimals = 1
    	    }
    	
        	return this['km2'+unit](v).toFixed(decimals) +' '+this.getSpeedUnit()
    	}
    	if(v < 10){
    	    decimals = 1
    	}
    	
		return (v).toFixed(decimals) +' '+this.getSpeedUnit()
    },
    getSpeedUnit : function(){
        let lang = settings.getLanguage()
        let unit = settings.getDistanceUnit()
        if (unit == 'mi'){
            switch(lang){
                case 'fr':
                    return 'mi/h'
                default:
                    return 'mph'
            }
        }        
        if (unit == 'km'){
            switch(lang){
                case 'fr':
                    return 'km/h'
                default:
                    return 'kph'
            }
        }
    },
    
    
    formatSpeedRange : function(v, decimals=0){
        let unit = settings.getDistanceUnit();
        if (unit == 'mi'){
            return this['km2'+unit](v[0]).toFixed(decimals) + ' - ' + this['km2'+unit](v[1]).toFixed(decimals) + ' mph'
        }
        return v[0].toFixed(decimals) + ' - ' + v[1].toFixed(decimals) + ' kph'
    },
    formatDuration(seconds, roundTo=60){
        let rounded = seconds - seconds % parseInt(roundTo)
        return humanizeDuration(rounded*1000, { language: settings.getLanguage() }) 
    },
    formatDurationRange(seconds, roundTo=60){
        let rounded1 = seconds[0] - seconds[0] % parseInt(roundTo)
        if(seconds.length == 2){
            let rounded2 = seconds[1] - seconds[1] % parseInt(roundTo) 
            
            if(rounded1 < 60*60 && rounded2 < 60*60){
                // both durations are under an hour, so will both be expressed in minutes
                // no need to say "x minutes - y minutes", then
                return parseFloat(rounded1/60).toFixed(0)+' - '+ humanizeDuration(rounded2*1000, { language: settings.getLanguage() }) 
            }
            
            return humanizeDuration(rounded1*1000, { language: settings.getLanguage() })+ ' - '+ humanizeDuration(rounded2*1000, { language: settings.getLanguage() })
        }
        
        return humanizeDuration(rounded1*1000, { language: settings.getLanguage() }) 
    },
    formatMoney : function(n='', digits=0){
    	if(isNaN(n)){
    		return "--"
    	}
        let l = settings.getI18nLocale()
        if (n == ""){
            digits = 0;
        }
        let formatter = new Intl.NumberFormat(l, {
          style: 'currency',
          currency: settings.getCurrency(),
          minimumFractionDigits: digits
        });
        
        //console.log(this.getCurrency())
        //console.log(formatter.format(n))
        if (n === ""){
            let amount = formatter.format(0).replace('0', '')
            return amount
        } else {
            return formatter.format(parseFloat(n).toFixed(digits))
        }
        
    },
    vehicleIcon : function(commute, size="18", color=""){
        let fn = ""
        try {
            fn = this.vehicle2IconFile(commute.data.vehicle)
            if(fn !== ""){
                if(color !== ""){
                    return '<img src="icons/'+fn+'_'+size+'_'+color+'.png">'
                }
                return '<img src="icons/'+fn+'_'+size+'.png">'
            }
        } catch(err){}
        return fn
    },
    vehicle2IconFile : function(vehicle){
        switch (vehicle['vehicle']){
            case 'other':
                switch(vehicle['other_vehicle']){
                    case 'walk' :                   
                        return 'pedestrian'
                    break;
                    case 'horse' :                   
                        return 'horse'
                    break;
                    case 'foot-scooter' :                   
                    case 'e-foot-scooter' :                   
                        return 'foot-scooter'
                    break;
                    case 'rollerblade' :                   
                        return 'rollerblade'
                    break;
                    case 'hoverboard' :                   
                    case 'e-monocycle' :                   
                        return 'monocycle'
                    break;
                    case 'boat' :                   
                        return 'boat'
                    break;
                    default:
                        return 'other'
                    break;
                }
            break;
            case 'e-bicycle':
                return 'bicycle'
            break;
            default:
                return vehicle['vehicle']
        }
    }
    

}